import { render, staticRenderFns } from "./Friendlinks.vue?vue&type=template&id=662e7242&scoped=true&"
import script from "./Friendlinks.vue?vue&type=script&lang=js&"
export * from "./Friendlinks.vue?vue&type=script&lang=js&"
import style0 from "./Friendlinks.vue?vue&type=style&index=0&id=662e7242&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662e7242",
  null
  
)

export default component.exports